/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useTranslation } from "react-i18next";
import ProductCarousel from "./ProductCarousel";
import ProductTitleVideo from "./ProductTitleVideo";
import ProductShare from "./ProductShare";
import ProductDesc from "./ProductDesc";

function WcBanyoTemizleyici() {
const [activeIndex, setActiveIndex] = useState(0);

const handleSelect = (selectedIndex) => {
setActiveIndex(selectedIndex);
};

const handlePrev = () => {
handleSelect(activeIndex === 0 ? 5 : activeIndex - 1);
};

const handleNext = () => {
handleSelect(activeIndex === 5 ? 0 : activeIndex + 1);
};

const { t } = useTranslation();

const [expanded, setExpanded] = useState(false);

const toggleNav = () => {
setExpanded(!expanded);
};

const handleClick = () => {
window.scrollTo(0, 0);
setExpanded(false);
};

return (
<>
    <SRLWrapper>
        <section class="product-details section-space">
            <div class="container">
                <div class="row gutter-y-50">
                    <div class="col-lg-6 col-xl-6 wow fadeInLeft" data-wow-delay="200ms">
                        <div class="product-details__img">
                            <div class="swiper product-details__gallery-top p-5">
                                <div className="album-list-item">
                                    <Link className="ali-link" onClick={handleClick} as={Link} to="/Armur">
                                    <div className="ali-img-wrap">
                                        <div>
                                            <img className="img-fluid blur-up lazyload" src="assets/images/20-kg/8.webp"
                                                alt="image" title="image" />
                                        </div>
                                    </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-6 wow fadeInRight" data-wow-delay="300ms">
                        <div class="product-details__content">
                            <div
                                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                                <ProductTitleVideo title="WC BANYO TEMİZLEYİCİ" video="" />
                                <span className="product-details__weight"
                                    style={{fontSize: '16px', fontWeight: 'bold', color: '#10adad'}}>
                                    5 KG - 20 KG
                                </span>
                            </div>
                            <span className="product-details__weight"
                                style={{fontSize: '16px', fontWeight: 'bold', color: '#10adad'}}>
                                5 KG - 20 KG
                            </span>

                            {/* Özellikler */}
                            <div class="product-details__excerpt mt-4">
                                <h5 class="mb-3">ÖZELLİKLERİ</h5>
                                <ul class="product-details__list">
                                    <li>Aside karşı dayanıklı tüm yüzeylerde oluşan kireç oluşumlarını temizlemede
                                        güvenle kullanılır.</li>
                                    <li>Sert yüzeyler, kalsiyum karbonat esaslı taşlar için uygun değildir. Mermer
                                        yüzeylerde kullanılmaz.</li>
                                    <li>Metal yüzeylerde güvenle kullanılır.</li>
                                    <li>Musluklar ve duşlar üzerinde oluşan kireç birikimlerini güvenle temizler.</li>
                                    <li>Sıvı olduğu için kullanımı kolaydır.</li>
                                    <li>Bileşimindeki yüzey aktif maddeler biyolojik olarak doğada parçalanır.</li>
                                    <li>Organik asit %5-15, noniyonik yüzey aktif madde %1-5 ve esans içerir.</li>
                                </ul>
                            </div>

                            {/* Kullanım Şekli */}
                            <div class="product-details__excerpt">
                                <h5 class="mb-3">KULLANIM ŞEKLİ</h5>
                                <ul class="product-details__list">
                                    <li>Direkt olarak ya da %10-50 oranında suyla seyreltilerek kullanılır.</li>
                                    <li>Yüzeylere uygulanır, silinir.</li>
                                    <li>Derzlerin etkilenmemesi için uzun süre yüzeyde bekletilmeden durulanır.</li>
                                </ul>
                            </div>

                            <div class="product-details__buttons">
                                <Link as={Link} to="/urunlerimiz" class="product-details__btn boskery-btn">
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__text">
                                    {" "}
                                    DİĞER ÜRÜNLERİMİZ
                                </span>
                                <i class="icon-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-details__description-wrapper">
                <div class="container">
                    <div class="product-details__description">
                        <h3 class="product-details__description__title">
                            Ürün Detayları
                        </h3>
                        <div class="product-details__text__box wow fadeInUp" data-wow-delay="300ms">

                            <div class="product-details__excerpt mt-4">
                                <h5 class="mb-3">ÜRÜN BİLEŞİMİ</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead class="table-dark">
                                            <tr>
                                                <th>MADDE ADI</th>
                                                <th>DERİŞİM</th>
                                                <th>CAS NO.*</th>
                                                <th>EC NO.*</th>
                                                <th>TEHLİKE İŞARETİ</th>
                                                <th>TEHLİKE İFADELERİ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Sülfamik Asit</td>
                                                <td>% 5-%15</td>
                                                <td>5329-14-6</td>
                                                <td>226-218-8</td>
                                                <td>Xl</td>
                                                <td>R 36/38-52/53</td>
                                            </tr>
                                            <tr>
                                                <td>Alkil Alkol Etoksilat</td>
                                                <td>&lt; % 5</td>
                                                <td>64425-86-1</td>
                                                <td>Polimer</td>
                                                <td>Xn, N</td>
                                                <td>R22-41-50</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="danger-warnings mt-4 p-3 bg-danger text-white">
                                <h6><strong>⚠️ ZEHİRLENME DURUMUNDA:</strong></h6>
                                <div class="alert alert-light mt-3 mb-3 text-dark">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-1"><strong>114'ü</strong></p>
                                            <p class="mb-0 small">ULUSAL ZEHİR DANIŞMA MERKEZİ</p>
                                        </div>
                                        <div class="col-md-6">
                                            <p class="mb-1"><strong>112'yi</strong></p>
                                            <p class="mb-0 small">ACİL SAĞLIK HİZMETLERİ</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="alert alert-warning mt-3 mb-0">
                                    <p class="mb-0">
                                        <strong>⚠️ DİKKAT :</strong> Üretim tarihi, son kullanma tarihi ile parti no ve
                                        seri no, ambalajın üzerindedir.
                                    </p>
                                </div>
                            </div>

                            <div class="product-info-box mt-4 p-3 bg-light">
                                <h6><strong>📋 TEKNİK BİLGİLER:</strong></h6>
                                <div class="row">
                                    <p><strong>Net Ağırlık:</strong> 5 KG ve 20 KG Seçenekleri mevcuttur.</p>
                                    <p><strong>Üretici Firma :</strong> Seymen Kimya Temizlik San. ve Tic. Ltd. Şti.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </SRLWrapper>

    <ProductDesc />
</>
);
}

export default WcBanyoTemizleyici;